import React from 'react';
import { useTranslate } from '../../../../../context/api-context/translations/use-translate';
import { Button, ButtonSize as SIZE, ButtonPriority as PRIORITY, HoverStyles, } from 'wix-ui-tpa/cssVars';
import { useConfiguration } from '../../../../../context/configuration-context/use-configuration';
import { unreachable } from '../../../../../../ts-utils';
import { useApi } from '../../../../../context/api-context/use-api';
import { getFollowedMemberById } from '../../../../../../common/store/members/members-selectors';
import { MEMBER_IS_FOLLOWED, MEMBER_FOLLOW_BUTTON, PENDING, } from '../../../../../../common/constants/data-hooks';
import classNames from 'classnames';
import { classes } from './follow-button.st.css';
const FollowButton = ({ memberId, name }) => {
    const { resourceId } = useConfiguration();
    const { followedMember, followMember, unfollowMember } = useApi((state, actions) => ({
        followedMember: getFollowedMemberById(state, memberId),
        followMember: actions.followMember,
        unfollowMember: actions.unfollowMember,
    }));
    const t = useTranslate();
    const { text, ...props } = (() => {
        const state = followedMember?.status ?? 'NOT_FOLLOWED';
        switch (state) {
            case 'FOLLOWED':
            case 'PENDING_FOLLOW': {
                return {
                    onClick: () => unfollowMember({ memberId, resourceId }),
                    priority: PRIORITY.basicSecondary,
                    text: t('member-follow-button.following'),
                    'aria-label': t('member-follow-button.following-aria-label'),
                };
            }
            case 'NOT_FOLLOWED':
            case 'PENDING_UNFOLLOW': {
                return {
                    onClick: () => followMember({ memberId, resourceId }),
                    priority: PRIORITY.basic,
                    text: t('member-follow-button.follow'),
                    'aria-label': t('member-follow-button.follow-aria-label'),
                };
            }
            default:
                throw unreachable(state);
        }
    })();
    const followActionInProgress = followedMember?.status === 'PENDING_FOLLOW' || followedMember?.status === 'PENDING_UNFOLLOW';
    return (React.createElement(Button, { className: classes.root, "data-hook": classNames(MEMBER_FOLLOW_BUTTON, followActionInProgress && PENDING, followedMember?.status === 'FOLLOWED' && MEMBER_IS_FOLLOWED), size: SIZE.tiny, disabled: followActionInProgress, upgrade: true, hoverStyle: HoverStyles.underline, ...props }, text));
};
export default FollowButton;
//# sourceMappingURL=follow-button.js.map